<template>
    <div class="flex justify-center flex-wrap">
        <div class='text-center' v-if="ACTION.e">
            <a :href='url(templateArgs.data.id)' class='btn btn-warning btn-sm btn-editar  btn-w' title='Editar'
                @click.prevent='buttonClick(templateArgs.data.id)'>
                <i class='fa fa-pencil-square-o'></i> Editar
            </a>
        </div>
        <div class='text-center' v-if="ACTION.d">
            <a href='#' class='btn btn-danger btn-sm btn-apagar btn-w' title='Apagar'
                @click.prevent='buttonClickApagar(templateArgs.data)'>
                <i class='fa fa-pencil-trash-o'></i> Apagar
            </a>
        </div>
    </div>
</template>

<script>
export default {
    name: 'templateAcoes',
    data() {
        return {
            templateArgs: {}
        }
    },
    computed: {
        ACTION() {
            return this.templateArgs.vm.ACTION
        },
    },
    methods: {
        url(id) {
            return `${this.templateArgs.vm.url}editar/${id}`
        },
        buttonClick(id) {
            this.templateArgs.vm.$router.push(`${this.templateArgs.vm.url}editar/${id}`)
        },

        buttonClickApagar(item) {
            return this.templateArgs.vm.buttonClickApagar(item)
        }
    }
}
</script>

<style lang="scss" scoped>
.img {
    width: 70px;
    height: 70px;
    object-fit: cover;
}
</style>